// /rf-admin/login ページ — RF 内部管理员登录
// UI 复刻 /login(globals.css 的 .login-* 样式),但行为独立:
// - 无 challenge_required 流(RF admin 不走二次验证)
// - 无 signup 链接
// - 成功跳转 /rf-admin/tenants(不是 /dashboard)

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../api/client";
import { rfAdminLogin } from "../api/client";

type State =
  | { phase: "idle"; error?: string }
  | { phase: "submitting" }
  | { phase: "error"; error: string };

export function RfAdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [state, setState] = useState<State>({ phase: "idle" });

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setState({ phase: "submitting" });
    try {
      const admin = await rfAdminLogin(email, password);
      // super → /rf-admin/tenants,sub → 同样
      navigate("/rf-admin/tenants", { replace: true, state: { admin } });
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : "ログインに失敗しました";
      setState({ phase: "error", error: msg });
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo" aria-hidden="true">
          <img src="/nexus-logo.png" alt="" />
        </div>
        <h1 className="login-title">RF Admin Console</h1>
        <p className="login-subtitle">内部管理者専用ログイン</p>

        <form className="login-form" onSubmit={onSubmit}>
          <div className="login-form-row">
            <label className="login-label">メールアドレス</label>
            <input
              className="login-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
              disabled={state.phase === "submitting"}
            />
          </div>

          <div className="login-form-row">
            <label className="login-label">パスワード</label>
            <input
              className="login-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={state.phase === "submitting"}
            />
          </div>

          {state.phase === "error" && (
            <div className="login-error">{state.error}</div>
          )}

          <button
            className="login-submit"
            type="submit"
            disabled={state.phase === "submitting"}
          >
            {state.phase === "submitting" ? "ログイン中..." : "ログイン"}
          </button>
        </form>
      </div>
    </div>
  );
}